import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useRestaurantContext } from "@/contexts/RestaurantContext";

export interface NfceIssued {
  id: string;
  restaurant_id: string;
  order_id: string | null;
  numero: number;
  serie: number;
  chave_acesso: string | null;
  protocolo: string | null;
  status: string;
  status_message: string | null;
  xml_enviado: string | null;
  xml_retorno: string | null;
  qrcode_url: string | null;
  danfe_url: string | null;
  valor_total: number;
  is_contingency: boolean;
  contingency_reason: string | null;
  cancelled_at: string | null;
  cancel_protocol: string | null;
  cancel_reason: string | null;
  created_at: string;
  updated_at: string;
}

export function useNfceHistory() {
  const { activeRestaurant } = useRestaurantContext();
  const [nfces, setNfces] = useState<NfceIssued[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchNfces = useCallback(async (filters?: {
    startDate?: string;
    endDate?: string;
    status?: string;
  }) => {
    if (!activeRestaurant?.id) return;

    try {
      setLoading(true);
      let query = supabase
        .from("nfce_issued")
        .select("*")
        .eq("restaurant_id", activeRestaurant.id)
        .order("created_at", { ascending: false });

      if (filters?.startDate) {
        query = query.gte("created_at", filters.startDate);
      }
      if (filters?.endDate) {
        query = query.lte("created_at", filters.endDate);
      }
      if (filters?.status) {
        query = query.eq("status", filters.status);
      }

      const { data, error } = await query.limit(500);

      if (error) throw error;
      setNfces(data || []);
    } catch (error) {
      console.error("Erro ao buscar NFC-e:", error);
    } finally {
      setLoading(false);
    }
  }, [activeRestaurant?.id]);

  useEffect(() => {
    fetchNfces();
  }, [fetchNfces]);

  return {
    nfces,
    loading,
    fetchNfces,
  };
}
